import React from 'react'

import AdvantagesSection from '.././AdvantagesSection'

const CardsSection = ({ activeType, currentImages, t }) => (
    <div className="mfb-cards-section">
        <div className="mfb-cards-section__ellipses">
            <span className="mfb-cards-section__ellipses-text">{t('From\nglobal brands')}</span>
            <div className="mfb-cards-section__ellipses-img">
                <img src={currentImages.ellipse.left} alt="" />
                <img src={currentImages.ellipse.right} alt="" />
            </div>
            <span className="mfb-cards-section__ellipses-text">{t('to club events')}</span>
        </div>
        <div className="mfb-cards-section__title">{t(activeType.texts.cardsTitle)}</div>
        {activeType.texts.cards.map((card, index) => (
            <div className="mfb-cards-section__card" key={`mfb-card-${index}`}>
                <div
                    className="mfb-cards-section__card-image"
                    style={{
                        backgroundImage: `url(${currentImages.cards[index]})`,
                    }}
                />
                <div className="mfb-cards-section__card-description">
                    <div className="mfb-cards-section__card-description-title">{t(card.title)}</div>
                    <div className="mfb-cards-section__card-description-text">
                        <div>{t(card.description)}</div>
                        {index === 3 ? (
                            <div className="mfb-cards-section__card-description-text-example-link">
                                https://interacty.me/projects/<span>oscars2020</span>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ))}
        <AdvantagesSection
            additionalClass={`${activeType.name}-cards-advantages`}
            advantages={activeType.texts.cardsAdvantages}
            images={currentImages.cardsAdvantages}
            t={t}
        />
    </div>
)

export default CardsSection
